import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { catalogGraphTranslationRef } from '@backstage/plugin-catalog-graph/alpha';

export const catalogGraphTranslation = TranslationBlueprint.make({
  name: 'catalog-graph',
  params: {
    resource: createTranslationMessages({
      ref: catalogGraphTranslationRef,
      full: false,
      messages: {
        'catalogGraphCard.title': 'Relaties',
        'catalogGraphCard.deepLinkTitle': 'Graaf bekijken',
        'catalogGraphPage.title': 'Catalogusgraaf',
        'catalogGraphPage.filterToggleButtonTitle': 'Filters',
        'catalogGraphPage.supportButtonDescription':
          'Volg je component door het toe te voegen aan de softwarecatalogus.',
        'catalogGraphPage.simplifiedSwitchLabel': 'Vereenvoudigd',
        'catalogGraphPage.mergeRelationsSwitchLabel': 'Voeg relaties samen',
        'catalogGraphPage.zoomOutDescription':
          'Knijp en zoom om door het diagram te bewegen. Klik om het actieve knooppunt te wijzigen, Shift-klik om naar de entiteit te gaan.',
        'catalogGraphPage.curveFilter.title': 'Curve',
        'catalogGraphPage.curveFilter.curveMonotoneX': 'Monotoon X',
        'catalogGraphPage.curveFilter.curveStepBefore': 'Stap vooraf',
        'catalogGraphPage.directionFilter.title': 'Richting',
        'catalogGraphPage.directionFilter.leftToRight': 'Links naar rechts',
        'catalogGraphPage.directionFilter.rightToLeft': 'Rechts naar links',
        'catalogGraphPage.directionFilter.topToBottom': 'Boven naar onder',
        'catalogGraphPage.directionFilter.bottomToTop': 'Onder naar boven',
        'catalogGraphPage.maxDepthFilter.title': 'Maximale diepte',
        'catalogGraphPage.maxDepthFilter.inputPlaceholder': '∞ Oneindig',
        'catalogGraphPage.maxDepthFilter.clearButtonAriaLabel':
          'wis maximale diepte',
        'catalogGraphPage.selectedKindsFilter.title': 'Soorten',
        'catalogGraphPage.selectedRelationsFilter.title': 'Relaties',
      },
    }),
  },
});
